import React, {Component} from 'react';
import {Header} from '../Header';
import {Footer} from '../Footer';
import {Helmet} from "react-helmet";

export class AccessibilityFI extends Component {
    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {
        return (
            <div>
                <Helmet>
                    <title>Saavutettavuusseloste - CamAPS FX</title>
                    <meta name="title" content="Saavutettavuusseloste"/>
                    <meta name="description"
                          content="CamDiab on sitoutunut edistämään ja parantamaan digitaalisten tuotteidensa saavutettavuutta ja käytettävyyttä kaikille ihmisille, myös henkilöille, joilla on to"/>
                    <meta property="og:locale" content="fi"/>
                    <meta name="keywords" content="saavutettavuusseloste"/>
                </Helmet>
                <Header props={this.props}/>
                <section className="inner-banner">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-12 col-sm-10">
                                <h1>Saavutettavuusseloste</h1>
                                <h3>Versio päivätty 11. syyskuuta 2026</h3>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="inner-page-content">
                    <div className="container">
                        <div className="row">
                            <div className="col-12 col-sm-12">
                                <p>
                                    CamDiab on sitoutunut edistämään ja parantamaan digitaalisten tuotteidensa saavutettavuutta ja käytettävyyttä kaikille ihmisille, myös henkilöille, joilla on toimintarajoitteita.
                                </p>
                                <h2>
                                    Vaatimustenmukaisuuden tila
                                </h2>
                                <p>
                                    CamDiab pyrkii noudattamaan verkkosisällön saavutettavuusohjeiden (WCAG) version 2.2 AA-tason vaatimuksia (WCAG 2.2 AA). Nämä maailmanlaajuisesti tunnustetut ohjeet auttavat tekemään verkkosisällöstä saavutettavampaa kaikille.
                                </p>
                                <h2>
                                    Saavutettavuutta tukevat lisätoimenpiteet
                                </h2>
                                <p>
                                    CamDiab toteuttaa muun muassa seuraavia lisätoimenpiteitä tehdäkseen digitaalisesta sisällöstämme helpommin käytettävää:
                                </p>
                                <ul>
                                    <li>Tarjoamme henkilöstöllemme jatkuvaa saavutettavuuskoulutusta</li>
                                    <li>Käytämme muodollisia saavutettavuuden laadunvarmistusmenetelmiä kolmannen osapuolen arviointien avulla</li>
                                    <li>Määritämme selkeät saavutettavuustavoitteet ja vastuualueet</li>
                                </ul>
                                <h2>
                                    Palaute
                                </h2>
                                <p>
                                    Otamme mielellämme vastaan palautetta siitä, miten voimme parantaa digitaalisia tuotteitamme käyttäjille, joilla on toimintarajoitteita. Jos sinulla on vaikeuksia sisältömme tarkastelussa tai siinä navigoinnissa tai huomaat sisältöä, ominaisuuden tai toiminnon, jonka uskot olevan puutteellisesti saavutettava henkilöille, joilla on toimintarajoitteita, ota meihin yhteyttä tukisähköpostimme kautta: <a href="mailto:support@camdiab.com">support@camdiab.com</a>
                                </p>
                                <p>
                                    Suhtaudumme palautteeseesi vakavasti ja otamme sen huomioon arvioidessamme tapoja palvella kaikkia asiakkaitamme ja kehittäessämme yleisiä saavutettavuusperiaatteitamme. Vaikka emme hallitse kolmansien osapuolten toimittamaa sisältöä, kannustamme niitä vahvasti tarjoamaan saavutettavaa ja käyttäjäystävällistä sisältöä.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>
                <Footer props={this.props}/>
            </div>
        );
    }
}
